A primitive picture gallery using BTS from the Hardy's regrets filing
todo: make it take the list of images from its user

<template>
  <div class="gallery container">
    <div class="row row-cols-1 row-cols-md-2 g-4">
      <div class="col" v-for="img in imgList" :key="img">
        <img :src="`/btsStills/${img}`"
             class="img-fluid" alt="gallery">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hr-bts-gallery",
  data() {
    return {
      imgList: [
        "GRA_0862a.jpg",
        "GRA_5131a.jpg",
        "GRA_5182a.jpg",
        "GRA_6390a.jpg",
        "GRA_6412a.jpg",
        "GRA_9899a.jpg",
        "GRA_1870@460w.jpg",
        "C4870BCE-CC74-4D2F-A8E4-13BE3F26C1A8.jpeg",
        "GRA_3790@460w.jpg",
        "GRA_1884@460w.jpg",     ]
    }
  },
  methods:{
    makeUrl( root, fileName){
      return root + '/btsStills/' + fileName
    }
  }
}
</script>